"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inProcessOrders = inProcessOrders;

require("@polkadot/api-augment");

var _rxjs = require("rxjs");

var _util = require("@polkadot/api-derive/util");

// Copyright 2017-2022 @darwinia/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
function orders(api) {
  return api.query.feeMarket.orders.keys().pipe((0, _rxjs.map)(datas => {
    return datas.map(_ref => {
      let {
        args: [item]
      } = _ref;
      return item;
    });
  }));
}
/**
 * @name inProcessOrders
 * @return orders Array<(laneId, MessageNonce)>
 * @description query in process orders
 * @example
 * <BR>
 *
 * ```javascript
 * api.derive.feeMarket.inProcessOrders((orders) => {
 *   console.log(`the current feeMarket processing orders are ${orders}`);
 * });
 * ```
 */


function inProcessOrders(instanceId, api) {
  return (0, _util.memo)(instanceId, () => orders(api));
}